import { Link } from "@mui/material";
import { ItemProperty, MaterialSymbolIcon, MaterialSymbols } from "src/components";
import { Links } from "src/constants";
import type { UserDto } from "src/http";

interface Props {
  user: UserDto;
}

const FormSubmissionRecipientProperty = (props: Props) => {
  return (
    <ItemProperty labelIcon={<MaterialSymbolIcon symbol={MaterialSymbols.ArticlePerson} />} label="Recipient">
      <Link href={Links.User(props.user.userId)}>{props.user.displayName}</Link>
    </ItemProperty>
  );
};

export { FormSubmissionRecipientProperty };
